// extracted by mini-css-extract-plugin
module.exports = {"headerUserPicture":"styles_headerUserPicture__l7IK4","headerUserPictureLink":"styles_headerUserPictureLink__zrUDb"};